import { render } from "./SectionWelcomeMobile.vue?vue&type=template&id=68e9bd05&scoped=true"
import script from "./SectionWelcomeMobile.vue?vue&type=script&lang=js"
export * from "./SectionWelcomeMobile.vue?vue&type=script&lang=js"

import "./SectionWelcomeMobile.vue?vue&type=style&index=0&id=68e9bd05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e9bd05"]])

export default __exports__